import Vue from 'vue';
import TextareaAutosize from 'vue-textarea-autosize';
Vue.use(TextareaAutosize);
